module.exports = __webpack_public_path__ + "img/weixin_law.09c4c295.jpg";